import React from 'react'
import { DataTool, type DataToolProps } from '@ztechapps/webui.data-tools'
import { useProjectListContext } from './Context'
import { projectListFieldConfig } from './constants'

export const ProjectListDataTool = ({ searchPlaceHolder = 'Search Projects', ...props }: DataToolProps) => {
  const { projectList, filterCategory } = useProjectListContext()

  return (
    <DataTool
      filterCategory={filterCategory}
      fieldsConfig={projectListFieldConfig}
      onRefresh={projectList?.refetch}
      searchPlaceHolder={searchPlaceHolder}
      {...projectList}
      {...props}
      onSort={null}
    />
  )
}
